import { forwardRef } from 'react';
import { Geometry2DRepresentation } from 'react-vtk-js';
import type { Geometry2DRepresentationProps } from 'react-vtk-js';

// vtk.js 36.2.0 Property2D defaults backfaceCulling to true; force culling off so 2D annotation faces (e.g. handles) aren't culled. See https://github.com/Kitware/vtk-js/commit/beea478a13ce421eed893e1cb18ebf31e1fb342b
const BatchedGeometry2DRepresentationWrapper: React.ComponentType<Geometry2DRepresentationProps> =
  forwardRef(({ property, ...props }: Geometry2DRepresentationProps, ref) => {
    return (
      <Geometry2DRepresentation
        {...props}
        property={{ backfaceCulling: false, frontfaceCulling: false, ...property }}
        ref={ref}
      />
    );
  });

BatchedGeometry2DRepresentationWrapper.displayName = 'BatchedGeometry2DRepresentationWrapper';

export default BatchedGeometry2DRepresentationWrapper;
